var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlocal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4325 2.81897L20.4903 2.81934L14.6694 20.2572L14.6691 20.2579C14.6277 20.3827 14.5492 20.4919 14.4437 20.5711C14.3404 20.6486 14.2162 20.6935 14.0869 20.7001L14.0439 20.7001C14.0437 20.7001 14.0435 20.7001 14.0432 20.7001C13.9147 20.6996 13.7894 20.6622 13.6823 20.5926L13.6822 20.5925C13.5844 20.5288 13.5055 20.441 13.4529 20.3378L11.1055 11.4304L11.0868 11.3593L11.0484 11.2966C10.9479 11.1325 10.7956 11.0077 10.617 10.9406L10.5935 10.9318L10.5693 10.9254L1.73409 8.58457C1.60641 8.53778 1.49617 8.45281 1.41836 8.34117C1.33832 8.22614 1.29706 8.08911 1.30022 7.94941C1.30579 7.81931 1.35073 7.69385 1.42932 7.58961L1.42932 7.5896C1.50855 7.48451 1.61804 7.40598 1.74372 7.36445L1.74488 7.36406L19.8312 1.33871L19.8312 1.33876L19.8377 1.33648C19.9925 1.28253 20.1619 1.28888 20.3116 1.3541L20.5111 0.896019L20.3116 1.3541C20.4615 1.41937 20.5808 1.53862 20.6461 1.68783C20.7113 1.83681 20.7176 2.00474 20.6639 2.15818L20.4325 2.81897Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlocal);
export default __webpack_public_path__ + "static/media/hyperlocal.f1660cef.svg";
export { ForwardRef as ReactComponent };